/** Correct existing prose mentions only. Never add branding or change URL paths. */
export function normalizeBrandSpelling(text: string): string {
  return text.replace(/https?:\/\/[^\s<>"']+|www\.[^\s<>"']+|[^\s<>"']+@[^\s<>"']+|\bfridge\.com\b/gi,
    value => /^fridge\.com$/i.test(value) ? 'Fridge.com' : value)
}

/** Sanitized HTML only: retain tags/attributes byte-for-byte and correct text. */
export function normalizeBrandHtml(html: string): string {
  return html.split(/(<(?:"[^"]*"|'[^']*'|[^'">])*?>)/g)
    .map(part => part.startsWith('<') ? part : normalizeBrandSpelling(part)).join('')
}

/** Public JSON copy only: keep keys, numeric data and URL destinations intact. */
export function normalizeBrandCopy<T>(value: T): T {
  if (typeof value === 'string') return normalizeBrandHtml(value) as T
  if (Array.isArray(value)) return value.map(item => normalizeBrandCopy(item)) as T
  if (value && typeof value === 'object') return Object.fromEntries(
    Object.entries(value).map(([key, item]) => [key, normalizeBrandCopy(item)])
  ) as T
  return value
}
